import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { WolfLink } from "@/pages/WolfPage";
import { MwpBadge } from "@/components/MwpBadge";
import { CrownFrame } from "@/components/CrownFrame";
import { BuyLink } from "@/components/BuyLink";

const MEDAL = ["text-amber-300", "text-slate-200", "text-orange-300"];
export const fmtMwp = (n) => (n >= 1e9 ? `${+(n / 1e9).toFixed(2)}B` : n >= 1e6 ? `${+(n / 1e6).toFixed(2)}M` : n >= 1e3 ? `${+(n / 1e3).toFixed(1)}K` : `${+n.toFixed(2)}`);

export default function MwpBoard() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(false);
  useEffect(() => { api.get("/holders/mwp").then(({ data }) => setD(data)).catch(() => setErr(true)); }, []);
  if (err) return <p className="text-red-300 text-sm" data-testid="lb-mwp-error">Couldn't load $MWP holders. Please refresh to try again.</p>;
  if (!d) return <p className="text-slate-500 text-sm">Counting the $MWP…</p>;
  if (!d.holders.length) return (
    <div data-testid="lb-mwp-empty" className="glass rounded-2xl p-6 text-sm text-slate-400 flex flex-wrap items-center justify-between gap-4">
      <span>No linked players hold $MWP yet. Hold it in the wallet you linked on NFT Boosts to top this board.</span>
      <BuyLink k="mwp" testid="lb-mwp-buy" />
    </div>
  );
  return (
    <ol data-testid="lb-mwp" className="space-y-3">
      {d.holders.map((e) => (
        <li key={e.rank} data-testid={`lb-mwp-row-${e.rank}`}
          className={`flex items-center gap-4 rounded-xl border px-4 py-3 transition-colors hover:border-amber-400/50 ${e.rank <= 3 ? "border-amber-400/30 bg-amber-500/5" : "border-slate-800 bg-slate-950/60"}`}>
          <span className={`font-display text-2xl w-8 text-center ${MEDAL[e.rank - 1] || "text-slate-500"}`}>{e.rank}</span>
          <CrownFrame tier={e.mwp_tier} small className="rounded-xl"><img src={e.portrait} alt={e.wolf_name} loading="lazy" className="w-14 h-14 rounded-xl object-cover border border-slate-700" /></CrownFrame>
          <div className="min-w-0 flex-1">
            <p className="font-display text-lg text-white truncate"><WolfLink name={e.wolf_name} testid={`lb-mwp-link-${e.rank}`} /></p>
            <p className="text-xs text-slate-400">Level {e.level}</p>
          </div>
          <MwpBadge tier={e.mwp_tier} testid={`lb-mwp-badge-${e.rank}`} />
          <span data-testid={`lb-mwp-balance-${e.rank}`} className="font-mono-game text-amber-200 text-lg w-24 text-right">{fmtMwp(e.balance)}</span>
        </li>
      ))}
    </ol>
  );
}
